interface ITaskSettings {
  allowMultiUserAssignment: boolean
  enablePlannedEffortHierarchy: boolean
}

export enum TaskSettingProperties {
  allowMultiUserAssignment = 'allowMultiUserAssignment',
  enablePlannedEffortHierarchy = 'enablePlannedEffortHierarchy'
}

export enum TaskSettingRequestTypes {
  allowMultiUserAssignment = 'allow-multi-user-assignment',
  enablePlannedEffortHierarchy = 'enable-planned-effort-hierarchy'
}

export interface ITaskSettingsResponse {
  type: TaskSettingRequestTypes
  enabled: boolean
  workspaceId?: string
}

export class TaskSettings implements ITaskSettings {
  allowMultiUserAssignment: boolean
  enablePlannedEffortHierarchy: boolean

  constructor(taskSettings: ITaskSettings) {
    this.allowMultiUserAssignment = !!taskSettings?.allowMultiUserAssignment
    this.enablePlannedEffortHierarchy = !!taskSettings?.enablePlannedEffortHierarchy
  }
}
